export default "__VITE_ASSET__CSZPrh$n__"